import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Button } from './Button';

export interface FilterBarProps {
  children: ReactNode;
  /** True when any filter differs from defaults — shows Reset. */
  dirty?: boolean;
  onReset?: () => void;
  resetLabel?: string;
  className?: string;
  trailing?: ReactNode;
}

/** Compact filter row with optional Reset when dirty. */
export function FilterBar({ children, dirty = false, onReset, resetLabel = 'Reset', className, trailing }: FilterBarProps) {
  return (
    <div className={cn('flex flex-col gap-3 border-b border-line p-4 lg:flex-row lg:items-center', className)}>
      <div className="flex min-w-0 flex-1 flex-col gap-3 lg:flex-row lg:items-center">{children}</div>
      <div className="flex shrink-0 items-center gap-2 self-start lg:self-auto">
        {dirty && onReset && (
          <Button variant="ghost" size="sm" onClick={onReset}>
            {resetLabel}
          </Button>
        )}
        {trailing}
      </div>
    </div>
  );
}
